import { Injectable } from "@angular/core";
import { User } from "@interface/User";
import { API } from "@config/Api";
import { Storage } from "@ionic/storage";
import { TranslateService } from "@ngx-translate/core";
@Injectable()
export class AuthService {
  private __isready: boolean = false;
  private __lang: string = "fr";
  private __rememberd: boolean = false;
  private __avatar: {
    small?: string;
    large?: string;
  } = {
    small: "assets/images/holders/avatar.jpeg",
    large: "assets/images/holders/avatar.jpeg",
  };
  private __wallpaper: {
    small?: string;
    large?: string;
  } = {
    small: "assets/images/holders/wallpaper.jpeg",
    large: "assets/images/holders/wallpaper.jpeg",
  };
  private __token?: string;
  private __user: User = {};
  private __LANGUAGES?: Array<{
    country?: {
      code?: string;
      id?: number;
      phonecod?: string;
      title?: string;
    };
    country_id?: number;
    id?: number;
    statu?: number;
    symbol?: string;
    title?: string;
  }> = [];

  private __PAGES?: Array<{
    icon?: string;
    path?: string;
    name?: string;
    subname?: string;
  }> = [
    {
      icon: "dashboard",
      path: "/",
      name: "ACCUEIL",
      subname: "Aperçu global",
    },
  ];

  constructor(
    private _storageCtrl: Storage,
    private _translateCtrl: TranslateService
  ) {}
  load(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._storageCtrl.get("auth").then(
        (auth) => {
          if (auth) {
            sessionStorage.setItem("auth", auth);
            this.__user = JSON.parse(auth).user;
            this.__token = JSON.parse(auth).token;
            this.setResources(this.__user.files);
            resolve({
              user: this.__user,
              token: this.__token,
            });
          } else {
            let authSession = sessionStorage.getItem("auth");
            if (authSession) {
              this.__user = JSON.parse(authSession).user;
              this.__token = JSON.parse(authSession).token;
              this.setResources(this.__user.files);
              resolve({
                user: this.__user,
                token: this.__token,
              });
            } else {
              reject();
            }
          }
        },
        () => {
          reject();
        }
      );
    });
  }
  private setResources(files) {
    files.forEach((file) => {
      const file_path = `${API.__REST_API_URL}/media/${file.id}.${file.mime.extention}`;
      if (file.users_files.resource == "WALLPAPER") {
        if (file.users_files.size == "S") {
          this.__wallpaper.small = file_path;
        } else {
          this.__wallpaper.large = file_path;
        }
      }
      if (file.users_files.resource == "AVATAR") {
        if (file.users_files.size == "S") {
          this.__avatar.small = file_path;
        } else {
          this.__avatar.large = file_path;
        }
      }
    });
  }
  authenticate(
    user,
    token,
    remember
  ): Promise<{
    user: User;
    token: string;
  }> {
    this.__rememberd = remember;
    return new Promise((resolve, reject) => {
      this.__user = user;
      this.__token = token;
      if (remember) {
        this.store("auth", {
          user,
          token,
        }).then(
          () => {
            resolve({ user, token });
          },
          () => reject()
        );
      } else {
        resolve({ user, token });
      }
    });
    // sessionStorage.setItem('auth', JSON.stringify({
    //     user,
    //     token
    // }))
    // this.setResources(this.__user.files);
    // if (remember) {
    //     this._storageCtrl.set('auth', JSON.stringify({
    //         user,
    //         token
    //     })).then(() => {
    //         resolve({
    //             user,
    //             token
    //         });
    //     }, error => {
    //         reject(error);
    //     });
    // } else {
    //     resolve({
    //         user,
    //         token
    //     });
    // }
    // });
  }
  public storage(v: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this._storageCtrl.get(v).then(
        (result) => {
          resolve(JSON.parse(result));
        },
        (err) => reject(err)
      );
    });
  }
  public store(key: string, value: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this._storageCtrl.set(key, JSON.stringify(value)).then(
        (result) => resolve(result),
        (err) => reject(err)
      );
    });
  }
  public get token() {
    return this.__token;
  }
  public logout(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._storageCtrl.clear().then(
        () => {
          resolve(true);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  private performI18n(
    keys: Array<string>,
    response: {},
    index: number,
    callback
  ) {
    this._translateCtrl.get(keys[index]).subscribe((res: string) => {
      response[keys[index]] = res;
      if (index > 0) {
        index--;
        this.performI18n(keys, response, index, callback);
      } else {
        callback(response);
      }
    });
  }

  public i18n(value: string | Array<string>): Promise<string | Array<any>> {
    return new Promise((resolve) => {
      if (Array.isArray(value)) {
        if (value.length > 0) {
          this.performI18n(value, {}, value.length - 1, (resutl) => {
            resolve(resutl);
          });
        }
      } else {
        this._translateCtrl.get(value).subscribe((res: string) => {
          resolve(res);
        });
      }
    });
  }

  get avatar() {
    return this.__avatar;
  }
  get rememberd() {
    return this.__rememberd;
  }
  get wallpaper() {
    return this.__wallpaper;
  }
  set LANGUAGES(value) {
    this.__LANGUAGES = value;
  }
  get LANGUAGES() {
    return this.__LANGUAGES;
  }

  set PAGES(value) {
    this.__PAGES = value;
  }
  get PAGES() {
    return this.__PAGES;
  }

  public get lang(): string {
    return this.__lang;
  }

  public set lang(v: string) {
    this.__lang = v;
  }

  public get user(): User {
    return this.__user;
  }
  public get isready(): boolean {
    return this.__isready;
  }
  public set isready(v: boolean) {
    this.__isready = v;
  }
  // public get token(): string {
  //     return this.__token;
  // }
}



// WEBPACK FOOTER //
// ./src/providers/auth.service.ts